<template>
	<div class="tb-fancy-loader loading">
		<div class="tb-fancy-loader-inner">
			<div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
			<div class="tb-fancy-loader-content">
				<div class="tb-fancy-loader-headings">
					<h2 v-for="(message,index) in dynamicMessages"
						:class="activeHeading == index ? 'active' : ''"
						:key="index">
						{{message.text}}
					</h2>
				</div>
				<p>{{staticMessage}}</p>
			</div>
		</div>
	</div>
</template>
<script lang="js">
	import { mapState } from 'vuex'
	import Vue from 'vue';

	export default Vue.extend({
		name: 'LoadingFancy',
		data: function(){
			return {
				activeHeading: null,
				staticMessage: 'This may take up to 30 seconds.',
				dynamicMessages: [
					{ text: 'Retrieving your credit score', time: 4000 },
					{ text: 'Adding in your personal details', time: 4000 },
					{ text: 'Firing up the algorithm', time: 4000 },
					{ text: 'Crunching some numbers', time: 4000 },
					{ text: 'Laying out your options', time: 4000 }
				],
				repeatDynamicMessages: true
			};
		},
		computed: {
			...mapState({
				vehicle: state => state.vehicle,
				finance: state => state.finance
			})
		},
		methods: {
			changeHeading(i){
				i = i < this.dynamicMessages.length ? i : 0;
				const h = this.dynamicMessages[i];
				this.activeHeading = i;
				setTimeout(() => {
					this.changeHeading(i+1)
				}, h.time);
			}
		},
		mounted(){
			this.activeHeading = 0;
			this.changeHeading(0);
		}
	});
</script>
